import React, { useMemo } from 'react';
import { Box, Popover, Typography } from '@mui/material';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import useInterveneSx from '../../hooks/useInterveneSx';
import useInterveneTheme from '../../hooks/useInterveneTheme';
import { ATTACHMENT_HINTS } from '../../utils/attachmentConstraints';

export default function ComposerAttachMenu({
  anchorEl,
  open,
  onClose,
  composerMode = 'active',
  isExpiredSession,
  onSelect,
}) {
  const styles = useInterveneSx().composer.attachMenu;
  const { attachMenu } = useInterveneTheme();
  const templateOnly = composerMode === 'expired'
    || composerMode === 'idle'
    || isExpiredSession === true;

  const menuItems = useMemo(
    () => [
      {
        id: 'template',
        label: 'Template',
        hint: 'Approved WhatsApp message',
        icon: ArticleOutlinedIcon,
        ...(attachMenu.template || {}),
      },
      {
        id: 'document',
        label: 'Document',
        hint: ATTACHMENT_HINTS.document,
        icon: AttachFileOutlinedIcon,
        ...(attachMenu.document || {}),
      },
      {
        id: 'image',
        label: 'Image',
        hint: ATTACHMENT_HINTS.image,
        icon: ImageOutlinedIcon,
        ...(attachMenu.image || attachMenu.photo || {}),
      },
      {
        id: 'video',
        label: 'Video',
        hint: ATTACHMENT_HINTS.video,
        icon: VideocamOutlinedIcon,
        ...(attachMenu.video || {}),
      },
      // {
      //   id: 'voice',
      //   label: 'Voice note',
      //   hint: 'Record audio message',
      //   icon: MicNoneOutlinedIcon,
      //   ...(attachMenu.voice || {}),
      // },
    ],
    [attachMenu]
  );

  const visibleItems = templateOnly
    ? menuItems.filter((item) => item.id === 'template')
    : menuItems;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{
        paper: { sx: styles.paper, elevation: 8 },
      }}
    >
      <Box sx={styles.list} role="menu" aria-label="Attach">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          return (
            <Box
              key={item.id}
              component="button"
              type="button"
              role="menuitem"
              sx={styles.item}
              onClick={() => onSelect(item.id)}
            >
              <Box sx={{ ...styles.iconCircle, bgcolor: item.bg, color: item.color }}>
                <Icon sx={{ fontSize: 20 }} />
              </Box>
              <Box sx={styles.itemCopy}>
                <Typography sx={styles.itemLabel}>{item.label}</Typography>
                {item.hint && (
                  <Typography sx={styles.itemHint}>{item.hint}</Typography>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Popover>
  );
}
